/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="meevomessenger.base.ts" />

module Meevo.Plugins.MeevoMessenger {
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;
    import IMeevoMessengerSettings = Meevo.Model.IMeevoMessengerSettings;
    import IMeevoMessengerAutoReply = Meevo.Model.IMeevoMessengerAutoReply;
    import IMeevoMessengerNewConversations = Meevo.Model.IMeevoMessengerNewConversations;
    import MeevoMessengerAutoRepliesEnum = Meevo.Model.MeevoMessengerAutoRepliesEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import Employee = Meevo.Model.Employee;
    import ClientListItem = Meevo.Model.ClientListItem;

    export abstract class MessengerComponentBase extends MeevoMessengerBase {

        protected securityParts = Meevo.Components.Common.SecurityParts;

        public recipientRoutingList: Array<IRecipientRouteParams> = [
            {
                label: 'LABEL_DISPLAY_CLIENT_PROFILE',
                isRouting: true,
                type: RecipientRouteType.DisplayClientProfile,
                options: {
                    actionState: MaintenanceFormState.Readonly,
                    initialEditSection: 'SECTION_CLIENT_MAIN',
                    initialEditSubSection: null,
                }
            }, {
                label: 'LABEL_DISPLAY_CLIENT_NOTES',
                isRouting: true,
                type: RecipientRouteType.DisplayClientNotes,
                options: {
                    actionState: MaintenanceFormState.Readonly,
                    initialEditSection: 'SECTION_CLIENT_NOTES',
                    initialEditSubSection: null
                }
            }, {
                label: 'LABEL_DISPLAY_FUTURE_APPOINTMENTS',
                isRouting: false,
                type: RecipientRouteType.DisplayFutureAppointments,
                options: {
                    onClick: this.onClientDisplayFutureAppointmentsClick.bind(this)
                }
            }, {
                label: 'LABEL_DISPLAY_CLIENT_TRANSACTION_HISTORY',
                isRouting: true,
                type: RecipientRouteType.DisplayTransactionHistory,
                options: {
                    actionState: MaintenanceFormState.Readonly,
                    initialEditSection: 'SECTION_HISTORY',
                    initialEditSubSection: 'TRANSACTION_HISTORY'
                }
            }, {
                label: 'LABEL_ADD_NEW_CLIENT_PROFILE',
                isRouting: true,
                type: RecipientRouteType.AddNewClientProfile,
                options: {
                    actionState: MaintenanceFormState.Adding,
                    initialEditSection: 'SECTION_CLIENT_MAIN',
                    initialEditSubSection: null
                }
            },
        ];

        public messageFilters = this.meevoMessengerService.messengerMessageFilters;
        public dateFilters = this.meevoMessengerService.messengerDateFilter;
        public messagesToTransfer: MeevoMessengerMessage[] = [];
        public conversationPreviewList: Array<MeevoMessengerConversation> = [];

        public searchQuery: string;
        public isFilterVisible: boolean = false;
        public isClientMessaging: boolean = true;

        public isCreatingNew: boolean = false;
        public isConversationViewVisible: boolean = true;
        public isSliderToggled: boolean = false;
        public isInTransferMode = false;

        public currentMessageFilter = this.meevoMessengerService.messengerMessageFilters[0]; // Default as All Messages
        public currentDateFilter = this.meevoMessengerService.messengerDateFilter[4]; // Default as last 7 days
        public recentlyReceivedFilter = null;

        public selectedUser: ClientListItem | Employee;
        public selectedPhoneNumber: string;
        public isEndOfMessages = false;
        public isNewMessagesList = false;
        public isRetakeConversationWindowHeight = false;
        public messageBodyRequest: any = {
            pageNumber: 0,
            itemsPerPage: 25,
            conversationId: null,
            classification: this.classification
        };
        public countryCode: string;

        private criteriaEmployeeSearch = {
            isGlobal: false,
            showEmployeesOnly: true,
            includeFullAccess: true
        };
        public autoReplyOptions: IMeevoMessengerAutoReply[] = [
            { type: MeevoMessengerAutoRepliesEnum.DefaultAutoReplyMessage, name: this.$translate.instant('LABEL_MEEVO_MESSENGER_DEFAULT_AUTO_REPLY_MESSAGE'), autoReplyMessage: '' },
            { type: MeevoMessengerAutoRepliesEnum.HolidayAutoReplyMessage, name: this.$translate.instant('LABEL_MEEVO_MESSENGER_HOLIDAY_AUTO_REPLY_MESSAGE'), autoReplyMessage: '' },
            { type: MeevoMessengerAutoRepliesEnum.OutsideHoursAutoReplyMessage, name: this.$translate.instant('LABEL_MEEVO_MESSENGER_OUTSIDE_HOURS_AUTO_REPLY_MESSAGE'), autoReplyMessage: '' }
        ];

        private sideNavClientInfo: ClientListItem;

        abstract intialSettingsSectionName: string;
        abstract undeleteConversationType: UndeleteConversationTypesEnum;
        abstract messageLengthLimit: number;

        abstract getOptOutStatus(): boolean;

        constructor(
            protected $mdSidenav: ng.material.ISidenavService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $filter: angular.IFilterService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService,
            protected meevoMessengerService: IMeevoMessengerService,
            protected meevoMessengerApiService: IMeevoMessengerApiService,
            protected $timeout: angular.ITimeoutService,
            protected classification: string,
            protected securityChecker: Meevo.Components.Common.ISecurityService
        ) {
            super({ identityService, $q, $rootScope, $state, busyService, meevoMessengerApiService, meevoMessengerService, $timeout, modalService, securityChecker });
            
            this.selectedMessenger = this;

            this.conversationBodyRequest = this.getDefaultConversationBodyRequest(true, this.defaultConversationBodyRequest);
            this.initMeevoMessengerConfiguration(contextParams.params);
            this.initEventHandler(contextParams.params);
        }

        initMeevoMessengerConfiguration(params): angular.IPromise<any> {
            const isGetClientList: boolean = params && params.isClient;
            return this.initSettings(isGetClientList).then(_ => {
                const isClient = params ? params.isClient : null;
                return this.meevoMessengerSettings && typeof isGetClientList === 'boolean' ? this.mapUserInformationToTheConversationWindow(isClient, params) : null;
            });
        }

        initEventHandler(params) {
            // Using this event to avoid bug
            // If we close meevoMessenger plugin, then we receive inbound message and instance of MeevoMessengerController is created
            this.$scope.$on(Meevo.Components.Common.Messages.STATE_CHANGE_SUCCESS, (event, toState, toParams, fromState, fromParams, options) => {
                if (toState.name !== this.appSettings.ROUTE_NAMES.meevoMessenger) return;

                let initialPromise = this.$q.resolve();

                if (!this.meevoMessengerSettings) {
                    initialPromise = initialPromise.then(() => {
                        return this.initMeevoMessengerConfiguration(params);
                    });
                }

                initialPromise.then(() => {
                    let newConversations: IMeevoMessengerNewConversations;

                    if (this.newConversations) {
                        newConversations = this.newConversations[this.notificationClassification];
                    }

                    if (!newConversations || !Object.keys(newConversations).length) return;

                    const isSelectedConversationHasNewMessage = this.selectedConversation && newConversations[this.selectedConversation.id.toString()];
                    this.conversationBodyRequest.offset = 0;
                    this.getConversationList(this.conversationBodyRequest).then(_ => {
                        if (!isSelectedConversationHasNewMessage) return;

                        this.loadConversation(this.selectedConversation.id);
                    });
                });
            });

            this.$scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, (event, state, params) => {
                if (state.name != this.appSettings.ROUTE_NAMES.meevoMessenger) return;
                // Check if redirect from client/employee plugins
                if (angular.isUndefined(params.isClient)) return;

                this.openConversations(params.isClient).then(() => {
                    const isClient = params ? params.isClient : null;
                    this.mapUserInformationToTheConversationWindow(isClient, params);
                });
            });

            this.$scope.$on(MeevoMessengerMessages.PROCESS_INBOUND_MESSAGE, (event: any, message: MeevoMessengerMessage) => {
                this.processInboundMessage(message);
            });

            this.$scope.$on(Meevo.Components.Common.Messages.TEXTEL_UPDATE_SYSTEM_AUTO_REPLY_TIMER, (event, state, params) => { //TODO: review and change to name like MESSENGER?
                if (!this.meevoMessengerSettings.isAutoReplyEnabled && this.meevoMessengerSettings.useBusinessHours) {
                    this.removeSystemAutoReplyTimer();
                    this.checkSystemTemplates();
                }
            });

            this.$scope.$on(Meevo.Components.Common.Messages.CONTEXT_HAS_CLOSED, (event, contextName: string) => {
                if (contextName !== this.appSettings.ROUTE_NAMES.meevoMessenger) return;

                this.removeSystemAutoReplyTimer();
            });

            // Need for synchronization with data from Textel Settings plugin
            this.$scope.$on(Meevo.Components.Common.Messages.TEXTEL_UPDATE_MODEL, (event: angular.IAngularEvent, settings: IMeevoMessengerSettings) => { //TODO: review and change to name like MESSENGER?
                // used for removing duplicates in messages on front-end side
                this.processSettings(settings);
                if (!this.meevoMessengerSettings.useBusinessHours) {
                    if (!this.meevoMessengerSettings.isAutoReplyEnabled) this.selectedAutoReply = null;
                    this.removeSystemAutoReplyTimer();
                }
            });

            this.$scope.$on(MeevoMessengerMessages.DELETING_CONVERSATION_CONFIRMATION, () => {
                this.deletingConversationConfirmation(this.selectedConversation);
            });

            this.$scope.$on(MeevoMessengerMessages.UNDELETE_CONVERSATION_MODAL, () => {
                this.undeleteConverationsModal();
            });

            this.$scope.$on(MeevoMessengerMessages.OPEN_MEEVOMESSENGER_SETTINGS, () => {
                this.openMeevoMessengerSettings();
            });

            this.$scope.$on(MeevoMessengerMessages.TOGGLE_AUTO_REPLIES, () => {
                this.toggleAutoReply();
            });

            this.$scope.$on(MeevoMessengerMessages.OPEN_CLIENT_OR_EMPLOYEE_CONVERSATION, (event: angular.IAngularEvent, settings: { isClient: boolean, isRefresh: boolean }) => {
                if (!settings.isRefresh) {
                    this.isClientMessaging = settings.isClient;
                    this.resetFilters();
                }
                this.openConversations(settings.isClient);
            });

            this.$scope.$on(MeevoMessengerMessages.CLEAR_TEXTEL_SETTINGS_AND_AUTH, () => {
                this.meevoMessengerSettings = null;
                this.isAccountInitialized = false;
                this.conversationMessageList = null;
                this.selectedConversation = null;
            });

        }

        initSettings(isGetClientList: boolean = true) {
            if (isGetClientList === null) isGetClientList = true;
            this.configFilters();

            this.busyService.start();
            return this.meevoMessengerApiService.getSettings(this.classification).then((settings: IMeevoMessengerSettings) => {
                if (!settings.isAccountInitialized) return this.$q.reject();

                this.processSettings(settings);

                return this.openConversations(isGetClientList);
            }).finally(() => {
                this.busyService.stop();
            });
        }

        configFilters() {
            this.dateFilters = this.meevoMessengerService.messengerDateFilter;
            this.messageFilters = this.meevoMessengerService.messengerMessageFilters;
            this.currentMessageFilter = this.messageFilters[0]; // Default as all Messages
            this.currentDateFilter = this.dateFilters[4]; // Default as last 7 days
        }

        sendMessage(msg: string): void {
            if (!msg) return;

            this.selectedPhoneNumber = this.preparePhoneNumber(this.selectedPhoneNumber);

            const userId: string = this.selectedUser
                ? this.getUserId(this.selectedUser)
                : null;

            if (this.isUsingBusinessPhoneNumber()) {
                this.modalService.alert('MESSAGE_MEEVO_MESSENGER_SAME_NUMBER_AS_BUSINESS');
                return;
            }

            this.busyService.start();
            this.meevoMessengerApiService.checkMeevoAIProfanity(msg)
                .then(res => {
                    if (!res.flagged) return this.splitAndSendMessage(msg, userId);

                    this.busyService.stop();
                    this.handleProfanityResult(res.filteredMessages, msg);
                })
                .catch(() => this.splitAndSendMessage(msg, userId))
                .finally(() => this.busyService.stop());
        }

        private isUsingBusinessPhoneNumber(): boolean {
            const numbersToCheck: string[] = [
                ...(this.selectedConversation ? [this.selectedConversation.phoneNumber] : []),
                ...(this.selectedUser ? [this.clientEmployeePhoneNUmber(this.selectedUser)] : []),
                this.selectedPhoneNumber
            ];

            return _.some(numbersToCheck, n => n === this.meevoMessengerSettings.userName);
        }

        private handleProfanityResult(filteredMessages: string[], outboundMessage: string): ng.IPromise<void | boolean> | void {
            const messageToPopulate = filteredMessages[0] || outboundMessage;

            const modalHandler = filteredMessages.length
                ? this.displaySuggestionsModal(messageToPopulate)
                : this.modalService.alert('LABEL_MESSAGE_NO_SUGGESTIONS_FOUND');
            return modalHandler
                .then(accepted => {
                    if (accepted) this.messageTextContent = messageToPopulate;
                });
        }

        splitAndSendMessage(msg: string, userId: string): void {
            const splitMessages = this.meevoMessengerService.getSplittedMessagesList(
                msg,
                this.messageLengthLimit
            );

            splitMessages.reduce(
                (promise: ng.IPromise<MeevoMessengerConversation>, nextMessage: string) =>
                    promise.then(conv =>
                        this.sendMessageCall(nextMessage, conv, this.classification, userId)
                    ),
                this.getSelectedConversation(this.isCreatingNew)
            );
        }

        toggleFilter() {
            this.isFilterVisible = !this.isFilterVisible;
        }

        clearFilter() {
            this.resetFilters();
            this.getConversationList(this.conversationBodyRequest)
        }

        resetFilters() {
            this.conversationBodyRequest = this.getDefaultConversationBodyRequest(this.isClientMessaging, this.defaultConversationBodyRequest);
            this.currentMessageFilter = this.messageFilters[0];
            this.currentDateFilter = this.dateFilters[4];
            this.recentlyReceivedFilter = null;
        }

        loadConversation(conversationId: Guid, isSilent?: boolean): void {
            this.messageBodyRequest.pageNumber = 0;
            this.isEndOfMessages = false;
            this.conversationMessageList = [];
            this.isCreatingNew = false;
            this.selectedUser = null;

            // Get full conversation from conversation id in ConversationPreview conversationId
            this.selectedConversation = this.meevoMessengerService.findConversation(this.conversationPreviewList, { id: conversationId });
            this.getConversationMessages(conversationId, isSilent).then(() => {
                if (!this.selectedConversation.lastMessage) {
                    this.selectedConversation.lastMessage = {} as Message;
                }
                this.selectedConversation.lastMessage.isRead = true;
            });

            this.getOptOutStatus();
            // Ensure mobile view
            this.toggleConversationView(true);
        }

        getConversationMessages(conversationId: Guid, isSilent?: boolean) {
            this.messageBodyRequest.conversationId = conversationId;

            if (!isSilent) this.busyService.start();

            return this.meevoMessengerApiService.getConversationMessages(this.messageBodyRequest)
                .then((messages: Array<MeevoMessengerMessage>) => {
                    this.busyService.stop();

                    // Infinitive scroll control
                    this.isNewMessagesList = true;
                    if (messages.length < 25) {
                        this.isEndOfMessages = true;
                        this.messageBodyRequest.pageNumber = 0;
                    }

                    // The work with new messages was moved to the next tick because of getting attachments logic
                    // A big amount of requests blocks markMessagesAsRead
                    this.$timeout(() => {
                        this.conversationMessageList = [
                            ...this.meevoMessengerService.preparedMessagesList(this.selectedConversation, messages,
                                this.timeZoneOffset, this.conversationMessageList.length ?
                                [this.conversationMessageList[0]] : [],
                                () => this.isRetakeConversationWindowHeight = true),
                            ...(this.conversationMessageList.length ? this.conversationMessageList.splice(1) : [])
                        ];
                    }, 0);

                    return this.meevoMessengerService.markMessagesAsRead(messages.length ? messages : [], this.classification);
                }).then(() => {
                    this.reduceBadgeNumber(conversationId);
                }).finally(() => {
                    this.busyService.stop();
                });
        }

        loadMoreMessages() {
            if (!this.isEndOfMessages) {
                this.messageBodyRequest.pageNumber += 1;
                this.getConversationMessages(this.selectedConversation.id);
            }
        }

        deletingConversationConfirmation(selectedConversation: MeevoMessengerConversation) {
            if (!selectedConversation) return;

            this.modalService.warning(
                'MESSAGE_DELETE_CONVERSATION',
                Meevo.Components.Modal.ModalTranslationModes.Translate,
                false,
                {
                    showCancelButton: true,
                    cancelButtonContentKey: 'LABEL_NO',
                    cancelButtonHotKey: 'MODAL_NO_BUTTON',
                    okButtonHotKey: 'MODAL_YES_BUTTON',
                    okButtonContentKey: 'LABEL_YES'
                }
            ).then((result: boolean) => {
                if (result) this.deleteConversationById(selectedConversation);
            });
        }

        deleteConversationById(selectedConversation: MeevoMessengerConversation) {
            selectedConversation.objectState = ObjectStateEnum.Deleted;
            this.updateConversation(selectedConversation).then((conversation: MeevoMessengerConversation) => {
                this.conversationPreviewList = this.conversationPreviewList
                    .filter((item: MeevoMessengerConversation) => conversation.id !== item.id);
                this.reduceBadgeNumber(selectedConversation.id);
                this.selectedConversation = null;
                this.conversationMessageList = [];
            });
        }
        
        undeleteConverationsModal() {
            this.modalService.showCustom({
                templateUrl: 'app/plugins/meevoMessenger/modals/undeleteConversation/undeleteConversationModal.html',
                escapeToClose: true,
                controller: 'meevo.plugins.meevoMessenger.modals.UndeleteConversationModalController',
                controllerAs: 'vm',
                locals: {
                    onUndeleteCallback: this.onUndeleteConversation.bind(this),
                    pointSummary: 'LABEL_MEEVO_MESSENGER_TEXTEL_UNDELETE_CONVERSATION_NOTE',
                    type: this.undeleteConversationType,
                    userHasAccessToViewPhoneNumber: this.userHasAccessToViewPhoneNumber,
                },
            });
        }

        onUndeleteConversation(conversation: MeevoMessengerConversation, options: IUndeleteConversationOptions) {
            const { isClientConversation } = options;
            if (this.isClientMessaging && !isClientConversation || !this.isClientMessaging && isClientConversation) {
                return;
            }

            if (this.selectedConversation && this.selectedConversation.phoneNumber === conversation.phoneNumber) {
                this.loadConversation(this.selectedConversation.id);
                this.selectedConversation.entityVersion = conversation.entityVersion;
                return;
            }

            const existingConversation = this.meevoMessengerService.findConversation(this.conversationPreviewList, { phoneNumber: conversation.phoneNumber });
            if (angular.isUndefined(existingConversation)) {
                this.conversationPreviewList.unshift(conversation);
            } else {
                existingConversation.entityVersion = conversation.entityVersion;
            }
        }

        /** Placeholder for create new conversation **/
        addNewConversation() {
            this.isCreatingNew = true;
            this.conversationMessageList = [];
            this.selectedPhoneNumber = null;
            this.selectedConversation = null;
            this.selectedUser = null;

            this.toggleConversationView(true);
        }

        toggleConversationView(setting?: boolean): void {
            if (setting) {
                this.isConversationViewVisible = setting;
            } else {
                this.isConversationViewVisible = !this.isConversationViewVisible;
            }
        }

        openConversations(isClientsConversations: boolean) {
            this.isClientMessaging = isClientsConversations;
            this.selectedUser = null;
            this.selectedPhoneNumber = null;
            this.selectedConversation = null;
            this.conversationMessageList = [];
            this.isPulseToggles = false;
            this.conversationBodyRequest.isClientList = isClientsConversations;
            this.conversationBodyRequest.isLastInbound = this.recentlyReceived;
            return this.getConversationList(this.conversationBodyRequest);
        }

        openSelectClientModal(transferData?: MeevoMessengerMessage[] | MeevoMessengerConversation): void {
            var modalTitle = this.isInTransferMode ? 'LABEL_TRANSFER_MESSAGES' : 'LABEL_ASSIGN_NUMBER';
            var modalCallback = this.isInTransferMode ? this.assignMessageIdsToClient : this.assignConversationIdToClient;

            this.meevoMessengerService.getDuplicatedUsers(this.selectedConversation.phoneNumber, this.isClientMessaging)
                .then((duplicateUsers: IUnifiedDuplicatedUser[]) => {
                    let options: Meevo.Components.Modal.IModalOptions = {
                        templateUrl: 'app/plugins/meevoMessenger/modals/selectClient/selectClientModal.html',
                        escapeToClose: false,
                        clickOutsideToClose: false,
                        locals: {
                            phoneNumber: Handlebars.compile(`{{format phoneNumber type='phoneFormat'}}`)({
                                phoneNumber: this.selectedConversation.phoneNumber
                            }),
                            duplicateUsers: duplicateUsers,
                            transferData: transferData,
                            modalTitle: modalTitle,
                            handleConfirm: modalCallback,
                        },
                        controller: 'meevo.plugins.SelectClientModalController',
                        controllerAs: 'vm'
                    };

                    this.modalService.showCustom(options);
                });
        }

        toggleTransferMode = (setting?: boolean) => {
            if (angular.isUndefined(setting)) {
                this.isInTransferMode = !this.isInTransferMode;
            } else {
                this.isInTransferMode = setting;
            }
        }

        toggleMessageToTransfer = (message: MeevoMessengerMessage) => {
            const idx: number = this.getMessagePositionFromTransferingArray(message.id);
            if (idx > -1) {
                this.messagesToTransfer.splice(idx, 1);
            } else {
                if (this.messagesToTransfer.length >= Meevo.Plugins.MeevoMessenger.Constants.MESSAGE_TRANSFER_LIMIT) return;
                this.messagesToTransfer.push(message);
            }
        }

        clearMessagesToTransfer = () => {
            this.messagesToTransfer = [];
        }

        assignConversationIdToClient = (conversationSettings: MeevoMessengerConversation, userId: Guid) => {
            if (this.isClientMessaging) conversationSettings.clientId = userId;
            else conversationSettings.employeeId = userId;

            conversationSettings.classification = this.classification;

            this.busyService.start();
            this.meevoMessengerApiService.updateConversation(conversationSettings).then((_) => {
                this.clearMessagesToTransfer();
                this.toggleTransferMode(false);

                return this.getConversationList(this.conversationBodyRequest);
            }).then(() => {
                this.loadConversation(conversationSettings.id);
            }).finally(() => {
                this.busyService.stop();
            });
        }

        assignMessageIdsToClient = (messages: MeevoMessengerMessage[], client: any) => {
            // TODO: Handle api call to update data
            //console.log('[assignMessageIdsToClient] with messageIds', messageIds, 'to clientId', client);

            this.clearMessagesToTransfer();
            this.toggleTransferMode();
        }

        transferMessage = () => {
            this.openSelectClientModal(this.messagesToTransfer);
        }

        cancelTransferMessage = () => {
            this.toggleTransferMode();
            this.clearMessagesToTransfer()
        }
        
        openMeevoMessengerSettings() {
            this.goToState(this.appSettings.ROUTE_NAMES.meevoMessengerSettings, {
                initialEditSection: this.intialSettingsSectionName
            });
        }

        getSelectedConversation(isNew?: boolean): ng.IPromise<MeevoMessengerConversation> {
            if (!isNew) return this.$q.resolve(this.selectedConversation);

            let conversationPromise: ng.IPromise<MeevoMessengerConversation>;

            // let's look if conversation with user still exist
            const settingsOfNewConversation = this.getSettingsOfNewConversation(this.selectedPhoneNumber, this.selectedUser);
            const existingConversation: MeevoMessengerConversation = this.meevoMessengerService.findConversation(this.conversationPreviewList, { phoneNumber: settingsOfNewConversation.phoneNumber });

            if (existingConversation && this.selectedPhoneNumber) {
                conversationPromise = this.$q.resolve(existingConversation);
            } else if (existingConversation) {
                const request = _.assign(angular.copy(existingConversation), angular.copy(settingsOfNewConversation));
                conversationPromise = this.updateConversation(request).then((conversation: MeevoMessengerConversation) => {
                    _.assign(existingConversation, conversation);
                    return conversation;
                });
            } else {
                // Redirect from client to employee and vice versa if conversation has other ID
                // Redirect client to employee if selected user with the same phone number
                conversationPromise = this.createNewConversation(settingsOfNewConversation).then((conversation: MeevoMessengerConversation) => {
                    // Todo: Refactoring it in the next phase. Think about better workflow
                    if (!this.selectedUser && conversation.clientId && !this.isClientMessaging || conversation.employeeId && this.isClientMessaging) {
                        return this.openConversations(!this.isClientMessaging).then(() => {
                            const existingConversation: MeevoMessengerConversation = this.meevoMessengerService.findConversation(this.conversationPreviewList, { phoneNumber: settingsOfNewConversation.phoneNumber });
                            if (!existingConversation) this.conversationPreviewList.unshift(conversation);
                            return existingConversation ? angular.copy(existingConversation) : conversation;
                        });
                    }

                    this.conversationPreviewList.unshift(conversation);
                    return conversation;
                });
            }

            return conversationPromise.then((conversation: MeevoMessengerConversation) => {
                this.loadConversation(conversation.id);
                return angular.copy(conversation);
            });
        }

        createNewConversation(conversationSettings: MeevoMessengerConversation): ng.IPromise<MeevoMessengerConversation> {
            return this.meevoMessengerApiService.createConversation(conversationSettings);
        }

        clientNavigation(conversation: MeevoMessengerConversation, recipientRoutParams: IRecipientRouteParams, customClientId?: Guid) {
            if (!this.isClientMessaging) return;

            if (!recipientRoutParams.isRouting) {
                recipientRoutParams.options.onClick();
                return;
            }

            let modifiedConversation = conversation;
            modifiedConversation.phoneNumber = conversation.phoneNumber;
            // modifiedConversation.countryCode = this.countryCode;// todo: countryCode??

            this.goToState(
                this.appSettings.ROUTE_NAMES.client,
                this.meevoMessengerService.getStateParamsForClientRouting(modifiedConversation, recipientRoutParams, this.onClientRoutingCallback.bind(this), customClientId)
            );
        }

        isShowClientMenuOption(recipientRouting: IRecipientRouteParams): boolean {
            const isShowAddNewClientProfileMenuItem = !this.selectedConversation.clientId && recipientRouting.label === 'LABEL_ADD_NEW_CLIENT_PROFILE';
            const isShowClientProfileMenuItems = this.selectedConversation.clientId && recipientRouting.label !== 'LABEL_ADD_NEW_CLIENT_PROFILE';

            return isShowAddNewClientProfileMenuItem || isShowClientProfileMenuItems;
        }

        loadMoreConversation() {
            if (this.conversationPreviewList.length < 100) return;
            this.busyService.start();
            this.conversationBodyRequest.offset = this.conversationPreviewList.length;
            this.conversationBodyRequest.limit = 100;
            this.meevoMessengerApiService.getConversationList(this.conversationBodyRequest).then(data => {
                this.isShowLoadMoreIcon = data.length == 100;
                const tempConversationPreviewList = [...this.conversationPreviewList, ...data];
                this.removeDuplicatesFromConversationList(tempConversationPreviewList);
            }).finally(() => {
                this.busyService.stop();
            })
        }

        clearConversationParams() {
            this.conversationBodyRequest.limit = 1;
            this.conversationBodyRequest.offset = 0;
        }


        activateByUser(isEmployee: boolean, phoneNumber: string | null = null) {
            this.activateConversationByUser(isEmployee, this.selectedUser, phoneNumber).then(conversationId => {
                if (!conversationId) return;
                this.loadConversation(conversationId);
            })
        }

        protected changeMessageStatus(message: any): void {
            if (this.selectedConversation && this.selectedConversation.id != message.conversationId) return;

            const msg = this.conversationMessageList.find(msg => msg.id === message.id)
            if (msg) {
                msg.status = message.status;
            }

            this.$scope.$apply();
        }


        protected mapUserInformationToTheConversationWindow(isClient: boolean, userInformation): void {
            this.countryCode = userInformation.countryCode;

            const phoneNumber = this.clientEmployeePhoneNUmber(userInformation, isClient);
            const existingConversation: MeevoMessengerConversation = this.meevoMessengerService.findConversation(this.conversationPreviewList, { phoneNumber: phoneNumber });

            this.isClientMessaging = isClient;
            if (!existingConversation) {
                this.selectedUser = angular.copy(userInformation);
                // Redirect from client to employee and vice versa if conversation has other ID
                // Redirect client to employee if selected user with the same phone number
                this.createNewConversation(this.getSettingsOfNewConversation(this.selectedPhoneNumber, userInformation)).then((conversation: MeevoMessengerConversation) => {
                    // Todo: Refactoring it in the next phase. Think about better workflow
                    if (conversation.clientId && !isClient || conversation.employeeId && isClient) {
                        return this.openConversations(!this.isClientMessaging).then(() => {
                            this.loadConversation(conversation.id);
                            return this.$q.reject();
                        });
                    }

                    this.conversationPreviewList.unshift(conversation);
                    this.loadConversation(conversation.id);
                });
                return;
            }

            if (isClient === this.isClientMessaging) {
                existingConversation.contactFirstName = userInformation.firstName;
                existingConversation.contactLastName = userInformation.lastName;
                existingConversation.displayName = userInformation.displayName;
                existingConversation.meevoFile = userInformation.meevoFile;

                if (isClient) {
                    existingConversation.clientId = userInformation.id;
                } else {
                    existingConversation.employeeId = userInformation.id;
                }
            }

            this.updateConversation(existingConversation).then((conversation: MeevoMessengerConversation) => {
                if (!conversation) return;

                _.assign(existingConversation, conversation);
                this.loadConversation(conversation.id);
            });
        }

        protected updateConversation(info: MeevoMessengerConversation) {
            this.busyService.start();
            return this.meevoMessengerApiService.updateConversation(info).finally(() => {
                this.busyService.stop();
            });
        }

        protected getSettingsOfNewConversation(selectedPhoneNumber: string, selectedUser: any): MeevoMessengerConversation {
            let conversationSettings: any = {
                objectState: ObjectStateEnum.Active,
                classification: this.classification,
                lastMessage: {
                    createdDateTime: moment().toDate()
                }

            };

            if (this.selectedPhoneNumber) {
                conversationSettings.phoneNumber = selectedPhoneNumber;
            } else {
                _.assign(conversationSettings, {
                    isRestricted: selectedUser.isRestricted,
                    contactFirstName: selectedUser.firstName,
                    contactLastName: selectedUser.lastName,
                    displayName: selectedUser.displayName,
                    meevoFile: selectedUser.meevoFile
                });
                // Need to check client or employee
                if (this.isClientMessaging) {
                    conversationSettings.phoneNumber = this.clientEmployeePhoneNUmber(<ClientListItem>selectedUser, this.isClientMessaging);
                    conversationSettings.clientId = selectedUser.id;
                } else {
                    conversationSettings.phoneNumber = this.clientEmployeePhoneNUmber(<Employee>selectedUser, this.isClientMessaging);
                    conversationSettings.employeeId = this.selectedUser.id;
                }
            }

            return conversationSettings;
        }

        getConversationName(selectedConversation: MeevoMessengerConversation, message?: MeevoMessengerMessage): string {
            return this.meevoMessengerService.getUserName(selectedConversation, message);
        }

        protected goToState(stateName: string, stateParams?: any): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: stateName,
                stateParams
            });
        }

        /**
         * OnClick callback for attachments
         * @param {MessageFilter} value
         */
        protected onImageExpand(imgSrc: string) {
            const options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/meevoMessenger/modals/expandedImage/expandedImageModal.html",
                escapeToClose: false,
                clickOutsideToClose: true,
                locals: { imgSrc },
                controller: 'meevo.plugins.ExpandedImageModalController',
                controllerAs: 'vm',
            }

            this.modalService.showCustom(options);
        }

        /**
         * OnChange callback for status filter
         * @param {MessageFilter} value
         */
        protected onStatusChanged(value: MessageFilter) {
            this.conversationBodyRequest = _.extendOwn(this.conversationBodyRequest, this.meevoMessengerService.getFilterSettingsByMessageStatus(value));
            this.conversationBodyRequest.offset = 0;
            this.getConversationList(this.conversationBodyRequest);
        }

        /**
         * OnChange callback for date filter
         * @param {number} changedDate
         * @param {any} changedValue
         */
        protected onDateFilterChanged(changedDate: number, changedValue: any): void {
            if (!this.isFirstTimeLogIn) return;


            if (this.meevoMessengerSettings && changedDate) {
                this.conversationMessageList = null;
                this.selectedConversation = null;
                this.conversationBodyRequest = _.extendOwn(this.conversationBodyRequest, this.defaultConversationBodyRequest);
                this.getConversationList(this.conversationBodyRequest);
                // this.$scope.$apply();
            }
        }

        /**
         * OnChange callback for search filter
         */
        protected onSearchFilterChanged() {
            if (!this.userHasAccessToViewPhoneNumber && !isNaN(+this.conversationBodyRequest.criteria.filter)) return;

            this.conversationBodyRequest = _.extendOwn(this.conversationBodyRequest, this.meevoMessengerService.getFilterSettingsByFilterOption(this.conversationBodyRequest));
            this.getConversationList(this.conversationBodyRequest);
        }

        /**
          * OnChange callback for recently received filter
          */
        protected onRecentlyReceivedFilterChanged() {
            if (!this.isMeevoMessengerInitialized) return
            this.conversationBodyRequest.isLastInbound = this.recentlyReceived;

            this.getConversationList(this.conversationBodyRequest);
        }

        /**
         * Callback for client routing after creating new profile, watching client info etc.
         * @param {Meevo.Model.Client} clientInfo
         */
        protected onClientRoutingCallback(clientInfo: Meevo.Model.Client) {
            if (!Model.Guard.isSomething(clientInfo)) return;

            const clientPhoneNumber = clientInfo.phoneNumbers.find((phoneNumber: Meevo.Model.Phone) => phoneNumber.isPrimary);

            return this.mapUserInformationToTheConversationWindow(true, {
                id: clientInfo.id,
                firstName: clientInfo.firstName,
                lastName: clientInfo.lastName,
                isRestricted: clientInfo.isRestricted,
                meevoFile: clientInfo.meevoFile,
                primaryPhoneNumber: clientPhoneNumber.number,
                countryCode: clientPhoneNumber.countryCode
            });
        }

        /**
         * Callback for client routing after clicking on Display Future Appointments
         */
        protected onClientDisplayFutureAppointmentsClick() {
            this.busyService.start();
            this.meevoMessengerService.getClientInfoForSideNav(this.selectedConversation.clientId)
                .then((clientInfo: Meevo.Model.Client) => {
                    this.sideNavClientInfo = clientInfo;
                    this.$mdSidenav('MeevoMessengerClient').open();
                })
                .finally(() => this.busyService.stop());
        }

        protected getMessagePositionFromTransferingArray(messageId: Guid): number {
            return _.findIndex(this.messagesToTransfer, (messageToTransfer: MeevoMessengerMessage) => {
                return messageToTransfer.id === messageId;
            });
        }

        protected isConversationSelected(conversationId: Guid): boolean {
            return conversationId === (this.selectedConversation && this.selectedConversation.id);
        }

        protected clientEmployeePhoneNUmber(param: any, isClient?: boolean): string {
            if (param && isClient) {
                this.countryCode = param.primaryPhoneNumberCountryCode || param.countryCode;
                return this.preparePhoneNumber(param.primaryPhoneNumber)
            }

            if (param && !isClient) {
                this.countryCode = param.countryCode;
                return this.preparePhoneNumber(param.phoneNumber)
            }
        }

        get isDisabledMessagingForm(): boolean {
            const isSelectedUserWithPhone = !!(this.selectedUser && ((<Employee>this.selectedUser).phoneNumber || this.isClientHaveMobilePhoneNumber));
            const isSetRecipient = isSelectedUserWithPhone || this.selectedPhoneNumber || this.selectedConversation;
            return !this.isMeevoMessengerInitialized || !isSetRecipient;
        }

        get isFilterOn(): boolean {
            return this.currentMessageFilter !== this.messageFilters[0] ||
                this.currentDateFilter !== this.dateFilters[4] ||
                this.recentlyReceivedFilter;
        }
        get recentlyReceived(): boolean | null {
            return this.recentlyReceivedFilter ? this.recentlyReceivedFilter : null;
        }

        get isMeevoMessengerInitialized(): boolean {
            return this.meevoMessengerSettings && this.meevoMessengerSettings.isAccountInitialized;
        }

        get isClientHaveMobilePhoneNumber(): boolean {
            return (<ClientListItem>this.selectedUser).primaryPhoneNumberType === Meevo.Model.PhoneTypeEnum.Mobile;
        }

        get displayMappingPhoneNumberAlert(): boolean {
            return !this.isCreatingNew && !!this.selectedConversation &&
                (this.isClientMessaging
                    ? this.selectedConversation.isMultipleClients
                    : this.selectedConversation.isMultipleEmployees);
        }
        get activeMessengerEnum() {
            return MessengersEnum;
        }

        get defaultConversationBodyRequest(): Record<string, any> {
            return {
                offset: 0,
                classification: this.classification,
                limit: 100
            }
        }

        get splitMessagesCountLimit() {
            return Meevo.Plugins.MeevoMessenger.Constants.SPLIT_SMS_COUNT_LIMIT;
        }

    }
}
